/**
 * @fileoverview GET handler for the "/users/preference_center" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { usersPreferenceCenter } from "./constants";
import type { UsersGetPreferenceCenterResult } from "./types";

export const getUsersPreferenceCenter = reactQueryFetcherAdapter(
  usersPreferenceCenter,
  async (signal: AbortSignal, id: string): Promise<UsersGetPreferenceCenterResult> => {
    return fetch("/users/preference_center", "GET", { id }, { signal });
  }
);
